import { useContext, useState } from "react";
import { useConversion } from "../../common/hooks/use.analytics";
import MedicareInformation from "../../common/components/MedicareInformation";
import { PrivacyActDialog } from "../../common/components/PrivacyActDialog";
import useCreateAccountApi, { CreateUnlockAccountResponse } from "../../common/hooks/useCreateAccountApi";
import { createOrUnlockAccountData } from "../createAccountContext";
import { AxiosResponse } from "axios";

export type MedicareInformationErrorHeaderKeys = "notFoundError" | "processTryAgain" | "completeItems" | 'alreadyHaveAccount';

const YourMedicareInformation = () => {
    const [isLoading, setIsLoading] = useState(false);
    const api = useCreateAccountApi();
    const { data, stepForward } = useContext(createOrUnlockAccountData);
    const conversion = useConversion("sign_up", "sign_up");

    const [apiResponse, setApiResponse] = useState<AxiosResponse<CreateUnlockAccountResponse> | null>(null);

    const [medicareNumberRef, setMedicareNumberRef] = useState<HTMLInputElement | null>(null);
    const [monthRef, setMonthRef] = useState<HTMLInputElement | null>(null);

    const { medicareNumber, coverageStartDate, part } = data;
    const callCreateAccount = async () => {
        setApiResponse(null);
        const response = await api.step1(medicareNumber, coverageStartDate, part);
        if (!response) {
            return;
        }
        setApiResponse(response);
        setIsLoading(false);
        if (response.status === 204) {
            stepForward();
        }
    };

    return (
        <>
            <PrivacyActDialog />
            <MedicareInformation
                title={"create_an_account"}
                conversionName={"sign_up"}
                conversion={conversion}
                nextCallback={callCreateAccount}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                setMedicareNumberRef={setMedicareNumberRef}
                setMonthRef={setMonthRef}
                medicareNumberRef={medicareNumberRef}
                monthRef={monthRef}
                apiResponse={apiResponse}
            />
        </>
    );
};

export default YourMedicareInformation;
